export interface MentionQuery {
  query: string;
  start: number;
  end: number;
}

// Ищем активный @-токен, в котором стоит каретка: '@' в начале строки или после пробела,
// без пробелов между '@' и кареткой. query — то, что набрано после '@' до каретки.
export function detectMentionQuery(value: string, caret: number): MentionQuery | null {
  const upto = value.slice(0, caret);
  const at = upto.lastIndexOf('@');
  if (at < 0) return null;
  const before = at === 0 ? '' : value[at - 1];
  if (before && !/\s/.test(before)) return null; // '@' должен начинать токен
  const query = upto.slice(at + 1);
  if (/\s/.test(query)) return null; // пробел закрывает меншен
  return { query, start: at, end: caret };
}

// Убираем фрагмент [start,end) (сам меншен становится чипом, в тексте не остаётся).
export function stripMentionFragment(value: string, q: MentionQuery): string {
  return value.slice(0, q.start) + value.slice(q.end);
}
